export const themes = {
    system: "system",
    dark: "dark",
    light: "light",
} as const